import React from 'react';

const MonarchLogo = ({ variant = 'mark', className = '' }) => {
  const isMark = variant === 'mark';
  return (
    <img
      src="/monarch-logo.jpg"
      alt="The Monarch Insurance"
      className={className}
      style={isMark ? {
        height: 40,
        width: 40,
        objectFit: 'cover',
        objectPosition: 'top',
        borderRadius: 8,
        background: '#fff',
        flexShrink: 0,
      } : {
        height: 56,
        width: 'auto',
        maxWidth: 200,
        objectFit: 'contain',
        objectPosition: 'left',
      }}
    />
  );
};

export default MonarchLogo;
